// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__CIK0i","sections":"HomePage_sections__om4oG"};